import {BRANDS, LANGUAGES} from 'const'
import {getLang} from 'utils/stringUtils'

const TX_GROUP_FAQ_URLS = {
  [LANGUAGES.DE]: 'https://info.tamedia.ch/onelog',
  [LANGUAGES.FR]: 'https://info.tamedia.ch/onelog_f',
}

const JOBCLOUD_FAQ_URLS = {
  [LANGUAGES.DE]: 'https://www.jobcloud.ch/c/de-ch/warum-jobcloud/faq-tutorials/#onelog',
  [LANGUAGES.FR]: 'https://www.jobcloud.ch/c/fr-ch/pourquoi-jobcloud/faq/#onelog',
  [LANGUAGES.EN]: 'https://www.jobcloud.ch/c/en/why-jobcloud/faq/#onelog',
}

const FAQ_URL = {
  [BRANDS.blick]: {
    [LANGUAGES.DE]: 'https://faq.blick.ch/s/topic/0TO7T0000004F3jWAE/onelog?language=de&tabset-6d62b=2',
  },
  // TxGroup
  [BRANDS.baz]: TX_GROUP_FAQ_URLS,
  [BRANDS.berneroberlander]: TX_GROUP_FAQ_URLS,
  [BRANDS.bernerzeitung]: TX_GROUP_FAQ_URLS,
  [BRANDS.bilan]: TX_GROUP_FAQ_URLS,
  [BRANDS.derbund]: TX_GROUP_FAQ_URLS,
  [BRANDS.derlandbote]: TX_GROUP_FAQ_URLS,
  [BRANDS.finanzundwirtschaft]: TX_GROUP_FAQ_URLS,
  [BRANDS.langenthalertagblatt]: TX_GROUP_FAQ_URLS,
  [BRANDS.lematindimanche]: TX_GROUP_FAQ_URLS,
  [BRANDS.schweizerfamilie]: TX_GROUP_FAQ_URLS,
  [BRANDS.sihltaler]: TX_GROUP_FAQ_URLS,
  [BRANDS.sonntagszeitung]: TX_GROUP_FAQ_URLS,
  [BRANDS.tagesanzeiger]: TX_GROUP_FAQ_URLS,
  [BRANDS.tamedia]: TX_GROUP_FAQ_URLS,
  [BRANDS.thalwileranzeiger]: TX_GROUP_FAQ_URLS,
  [BRANDS.thunertagblatt]: TX_GROUP_FAQ_URLS,
  [BRANDS.tribunedegeneve]: TX_GROUP_FAQ_URLS,
  [BRANDS.twentyfourhours]: TX_GROUP_FAQ_URLS,
  [BRANDS.zurcherunterlander]: TX_GROUP_FAQ_URLS,
  [BRANDS.zurichseezeitung]: TX_GROUP_FAQ_URLS,
  // JobCloud
  [BRANDS.jobs]: JOBCLOUD_FAQ_URLS,
  [BRANDS.jobup]: JOBCLOUD_FAQ_URLS,
  [BRANDS.wirtschaftsmedien]: {
    [LANGUAGES.DE]: 'https://www.handelszeitung.ch/vorteile-benutzerkonto',
  },
}

export const getFAQLink = brand => {
  const lang = getLang(window.location.search) || LANGUAGES.DE
  return FAQ_URL[brand][lang]
}
